// extracted by mini-css-extract-plugin
export default {"backStyle":"CalendarDayCell_backStyle__04eF1","dateTextStyle":"CalendarDayCell_dateTextStyle__LiVPF"};